import React, { useState, useRef } from "react";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip"; // The strip
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const AICTEApproval = () => {
  const [showForm, setShowForm] = useState(false);
  const topRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false); // Added state for mobile drawer

  const pdfList = [
    { id: 1, title: "Notification in Newspapers for Institute Level seats", src: "/images/program/admission-notification.jpeg", isWeb: false },
    { id: 2, title: "Notification in Newspapers Against CAP seats", src: "/images/program/TIMSCDR-Vacancy-Round.jpg", isWeb: false },
  ];

  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
    
    setMobileOpen(false); // Close drawer on mobile after making a selection
  };

  // Helper to check if the source is a PDF
  const isPdf = (src) => src.toLowerCase().endsWith(".pdf");

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        <div ref={topRef}>
          <PageHeader 
            title="Admission Notification" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Admission Notification' }]} 
          />
          {showForm && <BrochureForm setShowForm={setShowForm} />}
        </div>

        <div className="spv-main-content">
          
          {/* Mobile Overlay (Hidden on Desktop) */}
          <div 
            className={`spv-mobile-overlay ${mobileOpen ? "active" : ""}`}
            onClick={() => setMobileOpen(false)}
          />

          <aside className={`spv-sidebar-modern ${mobileOpen ? "mobile-open" : ""}`}>
            {/* Added topbar wrapper for the header text and close button */}
            <div className="spv-sidebar-topbar">
              <div className="spv-sidebar-header-text">NOTIFICATIONS</div>
              <button 
                className="spv-mobile-close" 
                onClick={() => setMobileOpen(false)}
                aria-label="Close menu"
              >
                &times;
              </button>
            </div>

            <nav className="spv-nav-group">
              {pdfList.map((item) => (
                <button
                  key={item.id}
                  className={`spv-nav-card ${activePdf.id === item.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(item)}
                >
                  <div className="spv-card-content">
                    {/* Icon logic: Shows Image icon for images, PDF icon for PDFs */}
                    <img 
                      src={isPdf(item.src) ? "/images/icons/pdf.svg" : "/images/icons/image-icon.svg"} 
                      onError={(e) => e.target.src = "/images/icons/pdf.svg"}
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{item.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area" key={activePdf.id}> 
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack" style={{ display: "flex", alignItems: "center" }}>
                
                {/* Mobile Toggle Button - Hidden on desktop via CSS */}
                <button 
                  className="spv-btn spv-btn-outline spv-mobile-toggle-inline" 
                  onClick={() => setMobileOpen(true)}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '6px'}}>
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                  </svg>
                  Docs
                </button>

                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              <div className="spv-action-group">
                <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src)}>
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                {/* Conditional Rendering: Check if it is a PDF or an Image */}
                {isPdf(activePdf.src) ? (
                  <iframe
                    src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                    className="spv-iframe-content secure-frame"
                    title="Document Viewer"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                ) : (
                  <img 
                    src={activePdf.src} 
                    alt={activePdf.title} 
                    className="spv-image-content"
                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                )}
              </div>
            </div>
          </main>
        </div>
        <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      </div>
      <Footer />
    </>
  );
};

export default AICTEApproval;